export default function IntroSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        {/* 募集要項 */}
        <div className="max-w-7xl mx-auto mb-24">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-16">
            募集要項
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-12">
            {/* 正職員 */}
            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-3xl p-8 lg:p-10 shadow-lg border border-cyan-100">
              <div className="inline-block px-6 py-2 bg-cyan-600 text-white rounded-full text-lg font-bold mb-6">
                正職員
              </div>
              
              <div className="space-y-6">
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">職種</h3>
                  <p className="text-lg text-gray-900">介護職/ヘルパー（正職員）</p>
                </div>
                
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">給与</h3>
                  <p className="text-2xl font-bold text-cyan-600">月給 215,000円 〜 285,000円</p>
                </div>
                
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">仕事内容</h3>
                  <p className="text-lg text-gray-900">訪問介護（身体介護・生活援助・服薬確認など）</p>
                </div>
                
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">応募要件</h3>
                  <p className="text-lg text-gray-900 mb-2">無資格可・未経験可</p>
                  <p className="text-base text-gray-700">無資格の場合は資格取得まで同行研修あり</p>
                </div>
                
                <div>
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">アクセス</h3>
                  <p className="text-base text-gray-900">JR横須賀線 東逗子駅徒歩7分</p>
                  <p className="text-base text-gray-900">京急 逗子葉山駅徒歩2分</p>
                </div>
              </div>
            </div>

            {/* パート・バイト */}
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-3xl p-8 lg:p-10 shadow-lg border border-teal-100">
              <div className="inline-block px-6 py-2 bg-teal-600 text-white rounded-full text-lg font-bold mb-6">
                パート・バイト
              </div>
              
              <div className="space-y-6">
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">職種</h3>
                  <p className="text-lg text-gray-900">介護職/ヘルパー（パート・バイト）</p>
                </div>
                
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">給与</h3>
                  <p className="text-2xl font-bold text-teal-600">時給 1,800円 〜 2,500円</p>
                </div>
                
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">勤務形態</h3>
                  <p className="text-lg text-gray-900 mb-2">日勤のみ可・無資格可・未経験可</p>
                  <p className="text-base text-gray-700">資格取得支援制度あり（入社2ヶ月以内）</p>
                </div>
                
                <div>
                  <h3 className="text-sm font-semibold text-gray-500 mb-2">アクセス</h3>
                  <p className="text-base text-gray-900">JR横須賀線 東逗子駅徒歩7分</p>
                  <p className="text-base text-gray-900">京急 逗子葉山駅徒歩2分</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 教育・スキルアップ */}
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          <div className="space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              教育・スキルアップ
            </h2>
            <p className="text-2xl text-cyan-600 font-medium leading-relaxed">
              丁寧なOJTと資格取得のための支援制度で、着実にスキルアップが叶います
            </p>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                まごころヘルパーは、新人職員が安心して働けるように、教育体制を整えています。入職後は同行訪問からスタートし、新人職員が自信を持てるまで先輩職員が丁寧にサポート。訪問先は、新人職員と利用者さまの相性を考慮しながら決めるのでご安心ください。ある程度の業務を覚えたら、「午前は1人で訪問し、午後から先輩職員に同行する」といった段階的な指導も実施しています。少しずつ1人で訪問する時間を増やし、本人が「同行は必要ない」と判断したタイミングで独り立ち。自分のペースで独り立ちを目指せるので、焦らずに業務の習得が叶う環境です。
              </p>
              <p>
                当事業所は資格取得のための支援制度で、職員たちのスキルアップを応援しています。介護職員初任者研修の資格を持っていない新人職員は、オンライン研修で勉強しつつ、同行訪問で生活援助のサポートを実施。働きながら資格取得を目指せるので、効率良くスキルアップが図れます。実際に、無資格から入職した先輩職員も活躍中。経験が浅い方もチャレンジしやすいことが、当事業所の魅力です。
              </p>
            </div>
          </div>

          <div className="h-[600px] rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/a204e36ee1f94b76bfc1f555b007b903.jpg"
              alt="教育・スキルアップ"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
